// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.horizontal-tabs-sec__list {
  display: flex;
  gap: 4px;
  overflow-x: auto;
  scrollbar-width: thin;
}
.horizontal-tabs-sec__tab {
  flex: 0 0 auto;
  padding: 8px 18px 8px;
  border: 0;
  border-bottom: 3px solid transparent;
  background: transparent;
  color: #60758d;
  font: inherit;
  font-weight: 600;
  font-size: medium;
  cursor: pointer;
}
.horizontal-tabs-sec__tab:hover {
  color: #075dc5;
}
.horizontal-tabs-sec__tab:focus-visible {
  outline: 2px solid #075dc5;
  outline-offset: -2px;
}
.horizontal-tabs-sec__tab--active {
  color: #075dc5;
  border-bottom-color: #075dc5;
  background-color: aliceblue;
}
.horizontal-tabs-sec__panel {
  padding-top: 16px;
}`, "",{"version":3,"sources":["webpack://./src/components/HorizontalTabNavigation/HorizontalTabSec.scss"],"names":[],"mappings":"AACE;EACE,aAAA;EACA,QAAA;EACA,gBAAA;EACA,qBAAA;AAAJ;AAGE;EACE,cAAA;EACA,qBAAA;EACA,SAAA;EACA,oCAAA;EACA,uBAAA;EACA,cAAA;EACA,aAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AADJ;AAGI;EACE,cAAA;AADN;AAGI;EACE,0BAAA;EACA,oBAAA;AADN;AAKE;EACE,cAAA;EACA,4BAAA;EACA,2BAAA;AAHJ;AAKE;EACE,iBAAA;AAHJ","sourcesContent":[".horizontal-tabs-sec {\n  &__list {\n    display: flex;\n    gap: 4px;\n    overflow-x: auto;\n    scrollbar-width: thin;\n  }\n\n  &__tab {\n    flex: 0 0 auto;\n    padding: 8px 18px 8px;\n    border: 0;\n    border-bottom: 3px solid transparent;\n    background: transparent;\n    color: #60758d;\n    font: inherit;\n    font-weight: 600;\n    font-size: medium;\n    cursor: pointer;\n\n    &:hover {\n      color: #075dc5;\n    }\n    &:focus-visible {\n      outline: 2px solid #075dc5;\n      outline-offset: -2px;\n    }\n  }\n\n  &__tab--active {\n    color: #075dc5;\n    border-bottom-color: #075dc5;\n    background-color: aliceblue;\n  }\n  &__panel {\n    padding-top: 16px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
